// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3XscZ","title":"Info_title__3i0Nu","links":"Info_links__23yL6","link":"Info_link__4GXxI","logo":"Info_logo__2gy_U"};